<template>
  <ChooseRole
    v-if="visible"
    :roleList="fpidData.user_data"
    :roleId="authData.role_id"
    @close="visible = false"
    @chooseRole="chooseRoleHandler"
  />
</template>

<script>
import ChooseRole from './ChooseRole.vue'
import { mapMutations, mapState } from 'vuex'
// import导入组件工具等
export default {
  components: {
    ChooseRole,
  },
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
    }),
  },
  data() {
    return {
      visible: false,
      authData: {},
      fpidData: {},
      callback: () => {},
    }
  },
  created() {
    this.$root.Bus.$on('showLoginFromGame', ({ authData, fpidData, callback }) => {
      this.$rum.report('in_game_login_show_role_list', {}, 4)
      this.initData(authData, fpidData)
      this.callback = callback
      this.visible = true
    })
    this.$root.Bus.$on('loginFromGame', ({ authData, fpidData, cacheLogin }) => {
      this.initData(authData, fpidData)
      this.loginFromGame(this.authData.role_id, cacheLogin)
    })
  },
  methods: {
    ...mapMutations(['SET_TOKEN']),
    initData(authData, fpidData) {
      this.authData = authData
      this.fpidData = fpidData
      if (
        this.authData &&
        !this.authData.role_id &&
        this.fpidData.user_data &&
        this.fpidData.user_data.length
      ) {
        this.$set(this.authData, 'role_id', this.fpidData.user_data[0].role_id)
      }
    },
    loginFromGame(role_id, cacheLogin) {
      //通知角色列表
      this.$store.commit('SET_ROLE_LIST', this.fpidData.user_data)
      this.$store.commit('SET_USER_IP', this.fpidData.ip_country_code)

      const userinfo = this.fpidData.user_data.find((item) => item.role_id === role_id)
      this.$utils.customLocalStorage.setItem('vptyp', 'in_game')
      this.$utils.customLocalStorage.setItem(process.env.VUE_APP_FPID_KEY, this.authData.user_uid)
      if (cacheLogin !== undefined) {
        this.$utils.customLocalStorage.removeItem('vplocl')
        this.$utils.customSessionStorage.removeItem('vpses')
        if (cacheLogin) {
          //缓存放到local
          this.$utils.customLocalStorage.setItem('vplocl', this.authData.token)
        } else {
          //不是七天到session
          this.$utils.customSessionStorage.setItem('vpses', this.authData.token)
        }
        this.SET_TOKEN(this.authData.token)
      }

      this.$root.Bus.$emit('sendmsg', {
        event: 'in_game_login',
        data: {
          ...userinfo,
          loginType: 'in_game',
        },
      })
      this.taLog(userinfo)
      this.visible = false
    },
    chooseRoleHandler(userinfo, cacheLogin) {
      this.loginFromGame(userinfo.role_id, cacheLogin)
      this.callback && this.callback()
    },
    taLog(userinfo) {
      const commonData = {
        fake_id: userinfo.role_id,
        server_id: userinfo.extra_info && userinfo.extra_info.value,
        index_id: this.$ta.getDistinctId(),
        to_type: this.$enum.LOGIN_TYPE[this.loginType],
        operator_type: 1,
      }

      if (this.gameId === '20195') {
        commonData.is_web_unlock = userinfo.pay_threshold === 1
      }

      this.$ta.track('vip_mall_combine', {
        ...commonData,
        ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
      })
      this.$rum.report('login_operator_type', { ...commonData }, 1)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
